export const forever = () => new Promise(() => { });
export const delay = async (n) => new Promise((resolve) => setTimeout(resolve, n));
export const konst = async (x) => x;
export const konstPromise = konst;
export const mapPromise = async (x, f) => f(await x);
